import React, { useEffect } from 'react';

import {
  NUMBER_OF_PDF_PRACTITIONER_RESULTS,
  SHOULD_GET_HG_DATA,
} from '../../../../../common/Constants';
import { useFilterProviderResults } from '../../../../../hooks/useProviderSearch/useProviderSearch';
import { usePrintPSX } from '../../../../../hooks/usePSXPrint/usePrintPSX';
import { ProviderSearchFilters } from '../../../../../models/ProviderSearch';
import {
  hideAskAIWidget,
  hideChat,
  hideToasts,
  hideYourFeedbackForm,
  hideYourOpinionMattersPopup,
} from '../ShareDrawer/utils';
import { PrintView } from './PrintView';

export type FilterProviderResultsPrintViewProps = {
  filters: ProviderSearchFilters;
  coverageType: string;
  initialPage: boolean;
  printPage: number;
  includeAdditionalFieldsForPrint: boolean;
  isClicked: boolean;
  setIsClicked: React.Dispatch<React.SetStateAction<boolean>>;
};

export const FilterProviderResultsPrintView = ({
  filters,
  coverageType,
  initialPage,
  printPage,
  includeAdditionalFieldsForPrint,
  isClicked,
  setIsClicked,
}: FilterProviderResultsPrintViewProps) => {
  const { results: pdfResults = [] } = useFilterProviderResults({
    pageNumber: printPage,
    pageSize: NUMBER_OF_PDF_PRACTITIONER_RESULTS,
    selectedFilters: filters,
    coverageType,
    shouldGetHGData: SHOULD_GET_HG_DATA,
    initialPage,
    includeAdditionalFieldsForPrint,
  });
  const { printPSXPage } = usePrintPSX();

  useEffect(() => {
    if (pdfResults?.length > 0 && isClicked) {
      hideChat(true);
      hideToasts(true);
      hideAskAIWidget(true);
      hideYourFeedbackForm(true);
      hideYourOpinionMattersPopup(true);
      printPSXPage();
      hideChat(false);
      hideToasts(false);
      hideAskAIWidget(false);
      hideYourFeedbackForm(false);
      hideYourOpinionMattersPopup(false);
      setTimeout(() => {
        setIsClicked(!isClicked);
      }, 400);
    }
  }, [pdfResults, isClicked]);

  return isClicked ? <PrintView selectedProviderList={pdfResults} /> : null;
};
